import { GraphQLFormattedError } from 'graphql';

export enum MembershipsConfigErrorCode {
  STRIPE_ACCOUNT_FOR_PARTNER_NOT_FOUND = 'STRIPE_ACCOUNT_FOR_PARTNER_NOT_FOUND',
  PARTNER_DOES_NOT_HAVE_STRIPE_ACCOUNT = 'PARTNER_DOES_NOT_HAVE_STRIPE_ACCOUNT',
  PARTNER_PRICE_POINT_DATA_NOT_FOUND = 'PARTNER_PRICE_POINT_DATA_NOT_FOUND',
}

export function getGraphQLErrorMachineCode(
  graphQLError: Pick<GraphQLFormattedError, 'extensions'>,
): MembershipsConfigErrorCode | null {
  const errorType =
    typeof graphQLError.extensions?.errorType === 'string'
      ? graphQLError.extensions.errorType
      : null;
  const errorCode =
    typeof graphQLError.extensions?.code === 'string' ? graphQLError.extensions.code : null;
  const machineCode = errorType ?? errorCode;

  return Object.values(MembershipsConfigErrorCode).includes(
    machineCode as MembershipsConfigErrorCode,
  )
    ? (machineCode as MembershipsConfigErrorCode)
    : null;
}
